<div class="card pcp__card">
  <header class="pcp__card__header">
    <div>
      <h6 class="t-bold" data-test-id="pcpCardHeader">
        {{ pcp | fullName: true }}
      </h6>

      @if (pcp.name) {
        <p class="t-caption" data-test-id="pcpCardHeaderText">
          PCP for {{ pcp.name }}
        </p>
      }
    </div>
  </header>

  <section class="pcp__card__prices">
    @for (config of attributeConfigs; track config) {
      <model-attribute
        [config]="config"
        [format]="true"
        [context]="pcp"
        [data-test-id]="'pcpCardAttribute_' + i"
      >
      </model-attribute>
    }
  </section>
</div>
